import { render, staticRenderFns } from "./QuotesForm.vue?vue&type=template&id=3ac148f7"
import script from "./QuotesForm.vue?vue&type=script&lang=js"
export * from "./QuotesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports